export const storeActions = {
    setCategories,
    setPlatform,
    setCategoryOrder
};

function setCategories(categories) {
    return dispatch => {
      return dispatch({ type: "SET_CATEGORIES", payload: categories });
    };
}

function setPlatform(platform) {
  return dispatch => {
    return dispatch({ type: "SET_PLATFORM", payload: platform });
  };
}

function setCategoryOrder(categoryOrder) {  
  return dispatch => {
    return dispatch({type: "SET_CATEGORY_ORDER", payload: categoryOrder})
  }
}